import firebase from "firebase";
const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyADMJ72oJdPqG7zNRuDFiG1_tRPPYPoZKw",
  authDomain: "farewell-diary-d.firebaseapp.com",
  databaseURL: "https://farewell-diary-d.firebaseio.com",
  projectId: "farewell-diary-d",
  storageBucket: "farewell-diary-d.appspot.com",
  messagingSenderId: "327157022568",
  appId: "1:327157022568:web:48033933d9f9dc91bc20dd",
  measurementId: "G-D12S45J9CX"

});

const auth = firebase.auth();
const db = firebaseApp.firestore();
const provider = new firebase.auth.GoogleAuthProvider();
const storage = firebase.storage();
export { auth, firebaseApp, provider, db , storage};
